(function () {
  'use strict';
  /**
   * @ngdoc function
   * @name com.module.core.controller:RouteCtrl
   * @description Redirect for acess
   * @requires $q
   * @requires $scope
   * @requires $state
   * @requires $location
   * @requires AppAuth
   **/
  angular
    .module('com.module.core')
    .controller('RouteCtrl', function (ApiService, AppAuth, $location,currentUser,$rootScope) {
      ApiService.checkConnection()
        .then(function () {
          console.log('ApiService.checkConnection success');
          if (!currentUser.id) {
            console.log('Redirecting to /login')
            $location.path('/login');
          } else {
            console.log('Redirecting to /app')
            $location.path('/app/projects');
          }
        })
        .catch(function (err) {
          console.log('ApiService.checkConnection err: ' + err);
          $location.path('/error');
        });

    });

})();
